"use client";

import { useLocale } from "hooks";
import React from "react";
import { styledLink } from "./Link.css";

type LinkVariant = "styled" | "unstyled";

const getClasses = (variant: LinkVariant, className: string | undefined) => {
  if (variant === "styled") {
    return className ? `${styledLink} ${className}` : styledLink;
  }

  return className;
};

type LinkProps = JSX.IntrinsicElements["a"] & {
  variant?: LinkVariant;
};
export const Link: React.FC<LinkProps> = ({
  href,
  children,
  className,
  variant = "styled",
  ...props
}) => {
  const locale = useLocale();

  const classes = getClasses(variant, className);

  return (
    <a
      {...props}
      href={locale === "en-US" ? `/us${href}` : href}
      className={classes}
    >
      {children}
    </a>
  );
};
